export default "__VITE_PUBLIC_ASSET__3b9d8e80__"